import client from '@js/client'
import resources from '@js/resources'
import { camelKeyToSnakeKey, snakeKeyToCamelKey } from '@js/str-utils'

const getDefaultState = () => {
  return {
    cache: {},
    page: 1,
  };
};

const searchExpert = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getResults: state => state.cache.results || []
  },
  mutations: {
    clearCache (state) {
      state.cache = {}
      state.page = 1;
    },
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    setCache (state, cache) {
      cache.results = cache.results.reduce((result, elem) => {
        elem = snakeKeyToCamelKey(elem);
        elem.user = snakeKeyToCamelKey(elem.user);
        elem.tenantUserSkills = elem.tenantUserSkills.reduce((skills, skill) => {
          skill = snakeKeyToCamelKey(skill);
          skills.push(skill);
          return skills;
        }, []);
        result.push(elem);
        return result;
      }, []);

      state.cache = cache;
      state.page = 1;
    },
    setPage (state, page) {
      state.page = page;
    },
  },
  actions: {
    async search ({ state, commit, rootGetters }, { bySkill, inputData, page, pageSize }) {
      const domain = await rootGetters['tenant/getTenantDomain'];

      const cache = await {
        bySkill: bySkill,
        inputData: typeof inputData === 'string' ? [inputData] : inputData,
        pageSize: pageSize,
      };

      const payload = await {
        inputData: cache.inputData,
        bySkill: cache.bySkill,
      };
      const params = await { page: page, pageSize: pageSize };

      const res = await client.post(
        resources['experts'](domain), camelKeyToSnakeKey(payload),
        { params: camelKeyToSnakeKey(params) });
      cache.pageNum = res.data.n_pages;
      cache.results = res.data.results;
      commit('setCache', cache);

      return res;
    },
  },
}

export default searchExpert;